export default __webpack_public_path__ + "static/media/Tiger's Gloves of Crouching Calm.09dac658.jpg";